// frontend/src/components/SelecaoCartaoModal/SelecaoCartaoModal.jsx

import React, { useState, useEffect } from 'react';
import { Modal, Select, Button, Form, message, List, Empty, Spin } from 'antd';
import { CreditCardOutlined, RightOutlined } from '@ant-design/icons';
import { getCartoes } from '../../services/cardService';
import { getErrorMessage } from '../../utils/errorHandler';
import MobileLaunchSheet from '../MobileLaunchSheet/MobileLaunchSheet';

const { Option } = Select;

const SelecaoCartaoModal = ({ isOpen, onClose, onSelect, isMobile = false }) => {
    const [form] = Form.useForm();
    const [cartoes, setCartoes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        if (isOpen) {
            setLoading(true);
            getCartoes()
                .then((data) => {
                    setCartoes(Array.isArray(data) ? data : data?.results || []);
                })
                .catch((error) => {
                    messageApi.error(getErrorMessage(error, 'Não foi possível carregar os cartões. Tente novamente.'));
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            form.resetFields();
        }
    }, [isOpen, messageApi, form]);

    const handleOk = () => {
        form.validateFields()
            .then((values) => {
                onSelect(values.cartaoId);
                form.resetFields();
            })
            .catch(() => {});
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    const handlePickCard = (cartaoId) => {
        onSelect(cartaoId);
        form.resetFields();
    };

    const cardList = (
        <Spin spinning={loading}>
            {!loading && cartoes.length === 0 ? (
                <Empty description="Nenhum cartão encontrado" />
            ) : (
                <List
                    dataSource={cartoes}
                    split={false}
                    renderItem={(cartao) => (
                        <List.Item style={{ padding: '6px 0', border: 'none' }}>
                            <Button
                                type="default"
                                block
                                size="large"
                                onClick={() => handlePickCard(cartao.id)}
                                style={{
                                    height: 'auto',
                                    minHeight: 52,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    textAlign: 'left',
                                    padding: '12px 16px',
                                    borderColor: 'var(--color-border, #E8E2D6)',
                                }}
                            >
                                <span style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
                                    <CreditCardOutlined style={{ fontSize: 20, color: '#1F4F4F', flexShrink: 0 }} />
                                    <span
                                        style={{
                                            fontSize: 16,
                                            fontWeight: 500,
                                            color: '#1F4F4F',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        {cartao.nome}
                                    </span>
                                </span>
                                <RightOutlined style={{ color: '#bfbfbf', flexShrink: 0 }} />
                            </Button>
                        </List.Item>
                    )}
                />
            )}
        </Spin>
    );

    if (isMobile) {
        return (
            <>
                {contextHolder}
                <MobileLaunchSheet
                    open={isOpen}
                    title="Selecionar Cartão"
                    onCancel={handleCancel}
                    hideSave
                >
                    {cardList}
                </MobileLaunchSheet>
            </>
        );
    }

    return (
        <Modal
            title="Selecionar Cartão de Crédito"
            open={isOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            destroyOnClose
            width={520}
            footer={[
                <Button key="back" onClick={handleCancel}>
                    Cancelar
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={handleOk}
                    disabled={!cartoes.length}
                >
                    Avançar
                </Button>,
            ]}
        >
            {contextHolder}
            <Form form={form} layout="vertical" name="selecao_cartao_form">
                <Form.Item
                    name="cartaoId"
                    label="Cartão para o Lançamento"
                    rules={[{ required: true, message: 'Por favor, selecione um cartão!' }]}
                >
                    <Select
                        showSearch
                        size="large"
                        placeholder="Selecione um cartão"
                        loading={loading}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            (option?.children ?? '').toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {cartoes.map((cartao) => (
                            <Option key={cartao.id} value={cartao.id}>
                                {cartao.nome}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default SelecaoCartaoModal;
